<form class="">
  <div class="">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Save Route</h4>
      </div>
      <div class="modal-body">
        <div class="card">
          <div class="card-body p-0">
            <div class="form-group">
              <div
                class="d-flex flex-column justify-content-center"
                *ngIf="loading"
              >
                <app-spinner></app-spinner>
              </div>
              <div
                class="alert alert-danger fade show"
                role="alert"
                *ngIf="errorMessage !== ''"
              >
                <i class="material-icons alert-icon">error</i>
                <div>{{ errorMessage }}</div>
                <button type="button" class="close" data-dismiss="alert">
                  <i class="modus-icon material-icons">close</i>
                </button>
              </div>
              <label for="txtName" class="font-weight-bold">Route Name</label>
              <input
                #name
                class="form-control"
                id="txtName"
                placeholder="Enter route name"
                type="text"
                name="saveRouteName"
                [(ngModel)]="saveRouteName"
                [ngClass]="{ 'is-invalid': routeUniqueValidation }"
                (keydown.enter)="keydownEvent($event)"
              />
              <p *ngIf="routeUniqueValidation" class="alert-danger">
                {{ routeUniqueValidation }}
              </p>
              <p
                *ngIf="saveRouteName.length > routeNameLength"
                class="alert-danger"
              >
                Route name should be less than {{ routeNameLength }} characters
              </p>
              <p *ngIf="isCheckingRouteName">checking route name...</p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="saveRouteModalRef.hide()" class="btn btn-outline-dark">
          Cancel
        </button>
        <button
          type="submit"
          [disabled]="
            saveRouteName.length < 1 || saveRouteName.length > routeNameLength
          "
          (click)="checkUniqueAndSaveRoute()"
          class="btn btn-primary"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</form>
